import React from 'react';
import { useRemVoice } from '../contexts/RemVoiceContext';

/**
 * Fixed mini dialer host. RemVoice.mount targets #rem-voice.
 * Visible whenever the user has a REM Voice agent mapping.
 * Inbound ringing is configured in Admin → User Management → VOIP settings.
 */
const RemVoiceDialer: React.FC = () => {
  const { enabled, error, isRegistered, status, lineBusy } = useRemVoice();

  if (!enabled) return null;

  return (
    <div
      className="fixed bottom-4 right-4 z-[60] flex flex-col items-end gap-2 pointer-events-none"
      aria-live="polite"
    >
      {error && (
        <div className="pointer-events-auto max-w-xs rounded-full bg-red-600 px-3 py-1.5 text-[11px] font-medium text-white">
          {error}
        </div>
      )}
      {lineBusy && !error && status !== 'answered' && status !== 'incoming' && (
        <div className="pointer-events-auto max-w-xs rounded-full bg-amber-500 px-3 py-1.5 text-[11px] font-medium text-white">
          Line in use
        </div>
      )}
      {!error && enabled && !isRegistered && status !== 'ended' && (
        <div className="pointer-events-auto rounded-full bg-slate-900 px-3 py-1.5 text-[11px] font-medium text-white">
          Connecting voice…
        </div>
      )}
      <div
        id="rem-voice"
        className="pointer-events-auto leading-none"
      />
    </div>
  );
};

export default RemVoiceDialer;
